export default __webpack_public_path__ + "static/media/not-verified-icon.49cfb323.svg";